const PREFIX = "arcana.dailyCard.";

export const todayKey = () => {
  const d = new Date();
  const y = d.getUTCFullYear();
  const m = String(d.getUTCMonth() + 1).padStart(2, "0");
  const day = String(d.getUTCDate()).padStart(2, "0");
  return `${y}-${m}-${day}`;
};

export const dailyCacheKey = (firstName, dateKey, language) =>
  `${PREFIX}${firstName.trim().toLowerCase()}.${dateKey}.${language}`;

// True when this consultant already revealed today's card (in any language).
export const hasDailyCardToday = (firstName) => {
  const head = `${PREFIX}${(firstName || "").trim().toLowerCase()}.${todayKey()}.`;
  try {
    return Object.keys(window.localStorage).some((k) => k.startsWith(head));
  } catch (_) {
    return false;
  }
};

// Wipe every cached consultant daily-card so the next visit faces a fresh face-down card.
export const clearDailyCards = () => {
  try {
    Object.keys(window.localStorage)
      .filter((k) => k.startsWith(PREFIX))
      .forEach((k) => window.localStorage.removeItem(k));
  } catch (_) {
    /* ignore */
  }
};

// Full reset: first name, notice acceptance and daily cards. Home resets its state on this event.
export const clearConsultant = () => {
  try {
    window.localStorage.removeItem("arcana.firstName.v1");
    window.localStorage.removeItem("arcana.disclaimer.accepted.v1");
  } catch (_) {
    /* ignore */
  }
  clearDailyCards();
  window.dispatchEvent(new Event("arcana:consultant-cleared"));
};
